import React, { useState, useEffect, createContext } from "react";
import "reset-css";
import "./index.scss";
import WebFont from "webfontloader";
import Loading from "components/loading";
import ImagesLoaded from "react-images-loaded";
import Main from "components/main";
import data from "assets/data.json";

const Data = createContext();

const criticalImages = [
	"images/logo_tass.svg",
	"images/introbg1.jpg",
	"images/introbg2.jpg",
	"images/introbg3.jpg",
	"images/image1.png",
	"images/image2.png",
	"images/image3.png"
];

const App = () => {
	const [fontLoaded, setFontLoaded] = useState(false);
	const [criticalImagesLoaded, setCriticalImagesLoaded] = useState(false);
	const [shareInitialized, setShareInitialized] = useState(false);
	const previewImages = data.map(item => item.preview);

	useEffect(() => {
		WebFont.load({
			classes: false,
			google: {
				families: ["Montserrat:900:cyrillic"]
			},
			active: () => setFontLoaded(true)
		});
	}, [setFontLoaded]);

	return (
		<>
			<Data.Provider
				value={{
					shareInitialized,
					setShareInitialized
				}}
			>
				<Main data={data} show={fontLoaded && criticalImagesLoaded} />

				<Loading show={fontLoaded} hide={!criticalImagesLoaded} />

				<ImagesLoaded
					style={{ display: "none" }}
					done={() => setCriticalImagesLoaded(true)}
				>
					{[...criticalImages, ...previewImages].map((item, i) => (
						<img key={i} src={item} alt="" />
					))}
				</ImagesLoaded>
			</Data.Provider>
		</>
	);
};

export { Data };
export default App;
